import { createContext, useContext, useState } from "react";

interface AuthContextProps {
  organizationId: string | null;
  setOrganizationId: (id: string | null) => void;
}

const AuthContext = createContext<AuthContextProps>({
  organizationId: null,
  setOrganizationId: () => {},
});

export function AuthContextProvider({ children }: { children: React.ReactNode }) {
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  return (
    <AuthContext.Provider value={{ organizationId, setOrganizationId }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  return useContext(AuthContext);
}
